import { SITE } from "../../lib/site";

export function LegalPage({ title, updated, sections, testId }) {
  return (
    <div className="max-w-3xl mx-auto px-4 py-10" data-testid={testId}>
      <h1 className="font-display font-extrabold text-3xl md:text-4xl text-[var(--navy)]">{title}</h1>
      <p className="text-sm text-slate-500 mt-1">Last updated: {updated}</p>
      <div className="mt-6 bg-white rounded-2xl border border-slate-200 p-6 md:p-8 space-y-6 text-slate-700 leading-relaxed">
        {sections.map(([h, body]) => (
          <section key={h}>
            <h2 className="font-display font-bold text-lg text-[var(--navy)]">{h}</h2>
            <div className="mt-1 space-y-2 text-sm md:text-base">{body}</div>
          </section>
        ))}
        <section className="rounded-xl bg-orange-50 border border-orange-100 p-4 text-sm">
          <p className="font-semibold text-[var(--navy)]">संपर्क · Contact</p>
          <p>{SITE.address}</p>
          <p>Email: <a href={`mailto:${SITE.contactEmail}`} className="text-[var(--buy)] font-semibold" data-testid={`${testId}-email`}>{SITE.contactEmail}</a></p>
        </section>
      </div>
    </div>
  );
}
